const publicHaspRenderer = vm => (data, type, row) => {
    return vm.GLOBAL.COUNTRY === "MX" ? row.public_hasp : "";
};

export { publicHaspRenderer };